import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "c-infinite-loading" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "c-infinite-loading__spacer" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_c_error_block = _resolveComponent("c-error-block")!
  const _component_c_spinner = _resolveComponent("c-spinner")!
  const _component_ion_infinite_scroll = _resolveComponent("ion-infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({ loadAction: _ctx.loadAction, loading: _ctx.loading, items: _ctx.items, currentPage: _ctx.currentPage, total: _ctx.total }))),
    _renderSlot(_ctx.$slots, "error", _normalizeProps(_guardReactiveProps({ reload: _ctx.reload, errorMessage: _ctx.errorMessage })), () => [
      (_ctx.errorMessage)
        ? (_openBlock(), _createBlock(_component_c_error_block, {
            key: 0,
            message: _ctx.errorMessage,
            onReload: _cache[0] || (_cache[0] = ($event: any) => (_ctx.reload()))
          }, null, 8, ["message"]))
        : _createCommentVNode("", true)
    ]),
    _renderSlot(_ctx.$slots, "spinner", _normalizeProps(_guardReactiveProps({ loading: _ctx.loading })), () => [
      _withDirectives(_createVNode(_component_c_spinner, {
        class: "ion-padding",
        "loading-text": _ctx.loadingText
      }, null, 8, ["loading-text"]), [
        [_vShow, _ctx.loading]
      ])
    ]),
    _createVNode(_component_ion_infinite_scroll, {
      onIonInfinite: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadAction())),
      threshold: _ctx.threshold,
      disabled: _ctx.isDisabled,
      ref: "ionInfiniteScrollRef"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["threshold", "disabled"])
  ]))
}